import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";

// Login Redux States
import { FORGET_PASSWORD } from "./actionTypes"
import { userForgetPasswordSuccess, userForgetPasswordError } from "./actions"
import { forgetPasswordApiLink } from "helpers/backend_helper";

function getForgetPasswordErrorMessage(error, fallback = "Failed to send reset link") {
  if (!error) return fallback
  if (typeof error === "string") return error
  const apiMessage =
    error?.response?.data?.message ||
    error?.response?.data?.Message ||
    error?.message
  return apiMessage || fallback
}

function* forgetUser({ payload: { user } }) {
  try {
    toast.loading("Please wait...")
    const payload = {
      userName: user.userName,
      userType:'Broker',
      portal:'office',
      turnstileToken: user.turnstileToken,
    }
    const response = yield call(forgetPasswordApiLink, payload)

    if (response?.success) {
      toast.dismiss()
      toast.success(
        "Password reset email sent successfully. Please check your inbox and spam/junk folder."
      )
      yield put(
        userForgetPasswordSuccess(
          "Reset link has been sent to your mailbox. Please check your inbox and spam/junk folder."
        )
      )
    } else {
      const message = response?.message || "Failed to send reset link"
      toast.dismiss()
      toast.error(message)
      yield put(userForgetPasswordError(message))
    }
  } catch (error) {
    const message = getForgetPasswordErrorMessage(error)
    toast.dismiss()
    toast.error(message)
    yield put(userForgetPasswordError(message))
  }
}

function* forgetPasswordSaga() {
  yield takeEvery(FORGET_PASSWORD, forgetUser)
}

export default forgetPasswordSaga
